import { Attr, HasMany, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { Site } from "./site"

@Model()
export class Location extends ApplicationRecord {
  public static readonly jsonapiType = "locations"

  @HasMany("sites") public sites!: Site[]

  @Attr() public name!: string

  @Attr() public latitude!: number

  @Attr() public longitude!: number

  @Attr() public timezone!: string
}
